import View from './view';
import React from 'react';
import {IOwnProps} from './model';
import {dateFormats} from '../../../../../shared/constants/date';
import {useIsDesktop} from '../../../../../shared/hooks/useIsDesktop';
import {capitalize} from '../../../../../shared/utils/text';
import {datePipe} from '../../../../../shared/pipes';

export const ProfileApplicationsItem: React.FC<IOwnProps> = ({application}) => {
  const isDesktop = useIsDesktop();

  return React.createElement(View, {
    subjects: [
      {
        label: 'ФИО',
        value: application?.cardholderName,
      },
      {
        label: 'Основание',
        value: `${capitalize(application?.typeApplicationName)}${
          application?.isChildApplication ? ' ребенку (законный представитель)' : ''
        }`,
      },
      {
        label: 'Дата подачи',
        value: datePipe(application?.dateTimeFiling),
      },
    ],
    historyTable: [
      ['Дата и время', 'Статус', 'Примечание'],
      ...(application?.statusHistory?.map((status) => [
        datePipe(status.date, dateFormats.fullDateWithTime) || '',
        status.statusName || '',
        status.note || '',
      ]) || []),
    ].map((row) => {
      if (!isDesktop) {
        row.length = 2;
      }

      return row;
    }),
    statusId: application?.statusId,
    statusName: application?.statusName,
    application,
  });
};
